import { createFileRoute } from "@tanstack/react-router";
import { DashboardLayout } from "@/projects/components/dashboard-layout";
import { Card } from "@/projects/components/ui/card";
import { useAuth } from "@/projects/lib/useStore";
import { getTeachers } from "@/projects/lib/store";

export const Route = createFileRoute("/teacher/profile")({
  head: () => ({ meta: [{ title: "Profile — Teacher" }] }),
  component: () => {
    const auth = useAuth();
    const t = getTeachers().find((x) => x.id === auth?.id);
    return (
      <DashboardLayout role="teacher" title="Profile" breadcrumb={["Home", "Profile"]}>
        <Card className="max-w-xl p-6">
          <div className="flex items-center gap-4">
            <div className="grid h-16 w-16 place-items-center rounded-full gradient-hero text-xl font-bold text-white">{auth?.name?.[0]}</div>
            <div>
              <div className="text-lg font-semibold">{auth?.name}</div>
              <div className="text-sm text-muted-foreground">{t?.subject}</div>
            </div>
          </div>
          <div className="mt-6 grid gap-3 text-sm">
            <Row k="Teacher ID" v={t?.id ?? "—"} />
            <Row k="Email" v={t?.email ?? "—"} />
            <Row k="Mobile" v={t?.mobile ?? "—"} />
            <Row k="Subject" v={t?.subject ?? "—"} />
            <Row k="Status" v={t?.active ? "Active" : "Inactive"} />
          </div>
        </Card>
      </DashboardLayout>
    );
  },
});

function Row({ k, v }: { k: string; v: string }) {
  return <div className="flex justify-between border-b py-2"><span className="text-muted-foreground">{k}</span><span className="font-medium">{v}</span></div>;
}
